import { Signal } from '@angular/core';
import { EnvironmentStore } from '@nx-vigil/core/web/environment/data-access';
import { Attributes, Context } from '@opentelemetry/api';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { BufferConfig } from '@opentelemetry/sdk-logs';
import {
  BatchSpanProcessor,
  Span,
  SpanExporter,
} from '@opentelemetry/sdk-trace-web';
import { firstValueFrom } from 'rxjs';
import { OTELAttributesService } from '../open-telemetry/otel-attributes.service';
import { registerOtelTracing } from '../open-telemetry/otel-instrument';

interface TraceConfig {
  sampling?: number;
}

export function setupTracing(
  environment: EnvironmentStore,
  attributesProvider: OTELAttributesService,
): () => Promise<void> {
  return async () => {
    const tracing: TraceConfig =
      (await firstValueFrom(environment.getConfiguration$('tracing'))) ?? {};

    const processor = new ContextBatchSpanProcessor(
      attributesProvider.attributes,
      new OTLPTraceExporter({
        url: `${location.origin}/traces`,
      }),
    );

    registerOtelTracing(
      tracing.sampling !== undefined ? tracing.sampling : 1.0,
      processor,
    );
  };
}

class ContextBatchSpanProcessor extends BatchSpanProcessor {
  public constructor(
    private readonly attributes: Signal<Attributes>,
    _exporter: SpanExporter,
    config?: BufferConfig,
  ) {
    super(_exporter, config);
  }

  public override onStart(_span: Span, _parentContext: Context): void {
    _span.setAttributes(this.attributes());

    super.onStart(_span, _parentContext);
  }
}
